import { useState, useRef, useCallback } from 'react';
import {Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment'
import { useEffect } from 'react';
import { getEventosCalendario } from '../../api/common';
import 'moment/locale/es'; 
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useAuth } from '../../hooks/useAuth';
import { AddEventCalendar } from './AddEventCalendar';
import { DetailEvent } from './DetailEvent';
import DetalleRegistro from './DetailRegistro';
import DetalleOT from './DetailOt';
import { GoogleCalendarConnect } from './GoogleCalendarConnect';
const localizer = momentLocalizer(moment);

export function CalendarioApp({id=null}){
    const [events, setEvents] = useState([]);
    const [detailEvent, setDetailEvent] = useState();
    const [isOpenAddEvent, setIsOpenAddEvent] = useState(false);
    const [isOpenDetailEvent, setIsOpenDetailEvent] = useState(false);
    const [isOpenDetailReg, setIsOpenDetailReg] = useState(false);
    const [isOpenDetailOt, setIsOpenDetailOt] = useState(false);
    const [refresh, setRefresh]=useState(false)
    const {userData:{_id:userId, role}} = useAuth();
    const isAdmin = role?.nombre === 'Admin';
    const [detalleRegistro, setDetalleRegistro] = useState();
    const [detalleOtCal, setDetalleOTCal]=useState()

    // Cache de eventos por rango: clave = "YYYY-MM-DD_YYYY-MM-DD"
    const cacheRef = useRef(new Map());

    const fetchRange = useCallback(async (fechaInicio, fechaFin) => {
        const key = `${moment(fechaInicio).format('YYYY-MM-DD')}_${moment(fechaFin).format('YYYY-MM-DD')}`;
        if (cacheRef.current.has(key)) {
            setEvents(cacheRef.current.get(key));
            return;
        }
        try {
            const { data: { data } } = await getEventosCalendario({ fechaInicio, fechaFin });
            const raw = Array.isArray(data) ? data : [...(data.registros || []), ...(data.programaciones || [])];
            const allEvents = raw.map(ev => ({
              ...ev,
              start: ev.start ? new Date(ev.start) : new Date(),
              end: ev.end ? new Date(ev.end) : new Date(ev.start || Date.now()),
            }));
            cacheRef.current.set(key, allEvents);
            setEvents(allEvents);
        } catch (err) {
            console.error('[CalendarioApp] Error al cargar eventos:', err);
        }
    }, []);

    const handleRangeChange = useCallback((range) => {
        let inicio, fin;
        if (Array.isArray(range)) {
            // vista semana/día: array de dates
            inicio = range[0];
            fin = range[range.length - 1];
        } else {
            // vista mes: { start, end }
            inicio = range.start;
            fin = range.end;
        }
        fetchRange(inicio, fin);
    }, [fetchRange]);

    const handleDetailEvent = (event) => {
        if(event.origenTarea=='Programación'){
            setIsOpenDetailEvent(true);
             setDetailEvent(event);
        }
        if(event.origenTarea=='Registro'){
            setDetalleRegistro(event)
            setIsOpenDetailReg(true);
        }
        if(event.origenTarea=='OT'){
            setDetalleOTCal(event)
            setIsOpenDetailOt(true);
        }
    }

    useEffect(() => {
        // Limpiar cache al refrescar
        cacheRef.current.clear();
        // Cargar el mes actual por defecto
        const inicio = moment().startOf('month').toDate();
        const fin = moment().endOf('month').toDate();
        fetchRange(inicio, fin);
    }, [refresh, fetchRange]);

    return(
    <>
        <div className="d-flex justify-content-end mb-2">
            <GoogleCalendarConnect isAdmin={isAdmin} />
        </div>
        <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{height: '70vh'}}
        views={['month', 'week', 'day', 'agenda']}
        onRangeChange={handleRangeChange}
        eventPropGetter={(event ,start, end, isSelected) => ({
            event,
            start,
            end,
            isSelected,
            style: { backgroundColor: event.bgColor, padding: '1px 2px', size:'sm', fontSize: '6px', fontWeight: 'bold'}
        })}
        messages={{
            next: ">",
            previous: "<",
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            agenda: "Agenda",
            noEventsInRange: 'No hay eventos para los proximos días.'
            }}
        onSelectEvent={(event) => handleDetailEvent(event)}
        />

        <AddEventCalendar setEvents={setEvents} events={events} isOpen={isOpenAddEvent} setIsOpen={setIsOpenAddEvent} setRefresh={setRefresh} />    

        {detailEvent &&
            <DetailEvent event={detailEvent}  setEvents={setEvents} events={events} refresh={refresh} setRefresh={setRefresh} isOpen={isOpenDetailEvent} setIsOpen={setIsOpenDetailEvent} />
        }
        {
        detalleRegistro && 
            <DetalleRegistro evento={detalleRegistro} setDetalleRegistro={setDetalleRegistro} isOpen={isOpenDetailReg} setIsOpen={setIsOpenDetailReg} setRefresh={setRefresh}/>
        }
        {
        detalleOtCal&&
        <DetalleOT evento={detalleOtCal} setDetalleRegistro={setDetalleOTCal} isOpen={isOpenDetailOt} setIsOpen={setIsOpenDetailOt} setRefresh={setRefresh}/>
        }
    </>)
}